import styled from 'styled-components';
import { IconArrow, IconCheck, IconClose, IconDocument, IconDownload, IconPdf, IconTrash } from '../../icons';
import Load from 'components/load';

export const Container = styled.div`
  background-color: rgba(0, 0, 0, 0.7);
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  z-index: 998;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
`;

export const Box = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  border-radius: 14px;
  background-color: ${({ theme }) => theme.colors.white};
  width: 100%;
  max-width: 684px;
  padding: 25px;
  z-index: 999
`;

export const TitleArea = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: row;
  width: 100%;
`;

export const Title = styled.h3`
  color: ${({ theme }) => theme.colors.text};
  font-family: ${({ theme }) => theme.fontFamily.poppins.semiBold};
  font-size: 24px;
  margin: 0 0 5px;
`;

export const Description = styled.p`
  color: ${({ theme }) => theme.colors.text};
  font-family: ${({ theme }) => theme.fontFamily.poppins.regular};
  font-size: 16px;
  margin: 0 0 15px;
  text-align: center;
`;

export const AttachmentArea = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  width: 100%;
  margin: 18px 0px 0;
`;

export const AttachmentItem= styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  background-color: #F5F5F5;
  padding: 12px;
  border-radius: 8px;
  margin-bottom: 12px;
`;

export const AttachmentName = styled.div`
  font-size: 14px;
  color: ${({ theme }) => theme.colors.text};
  font-family: ${({ theme }) => theme.fontFamily.poppins.regular};
  text-align: center;
  margin: 0px;
`;

export const AttachmentActions = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
`;

export const WarnEmpty = styled.p`
  font-size: 14px;
  color: ${({ theme }) => theme.colors.text};
  font-family: ${({ theme }) => theme.fontFamily.poppins.regular};
  margin: 18px 0px 12px;
  text-align: center;
`;

export const ResumeInput = styled.input`
  display: none;
`;

export const ResumeContent = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
`;

export const ResumeName = styled.p`
  font-size: 14px;
  color: ${({ theme }) => theme.colors.text};
  font-family: ${({ theme }) => theme.fontFamily.poppins.regular};
  text-align: center;
  margin: 0;
  margin-right: 30px;
`;

export const ResumeAddButton = styled.p`
  font-size: 14px;
  color: ${({ theme }) => theme.colors.text};
  font-family: ${({ theme }) => theme.fontFamily.poppins.regular};
  text-align: center;
  transition: color 350ms ease;
  text-decoration: underline;
  margin: 0;
  cursor: pointer;
  @media only screen and (min-width: 1024px) {
    &:hover {
      color: ${({ theme }) => theme.colors.secondary};
    }
  }
`;

export const Button = styled.div<{ accept?: boolean, bg?: string, textColor?: string }>`
  border-radius: 3px;
  padding: 4px 16px;
  background-color: ${({ theme, accept, bg }) =>
    bg ? bg : accept ? theme.colors.red : theme.colors.redUltraLight};
  font-family: ${({ theme }) => theme.fontFamily.poppins.regular};
  color: ${({ theme, accept, textColor }) => textColor ? textColor : accept ? theme.colors.white: theme.colors.textSecondary};
  cursor: pointer;
  transform: scale(1);
  transition: transform 350ms ease;
  font-size: 14px;
  @media only screen and (min-width: 1024px) {
    &:hover {
      transform: scale(1.25);
    }
  }
`;

// Load
export const LoadRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
`;

export const LoadingIndicator = styled(Load).attrs(({theme}) => ({
  size: 'large',
  customStyle: {
    color: theme.colors.secondary,
       width: 40,
        height: 40,
        marginBottom: 12,
  }
}))`
  display: flex;
  align-items: center;
  justify-content: center;
`;

// Icons
export const CloseIcon = styled(IconClose).attrs(({theme}) => ({
  width: 20,
  height: 20,
  color: theme.colors.red
}))`
  cursor: pointer;
  transform: scale(1);
  transition: transform 350ms ease;
  @media only screen and (min-width: 1024px) {
    &:hover {
      transform: scale(1.25);
    }
  }
`;

export const CloseSmallIcon = styled(IconClose).attrs(({theme}) => ({
  width: 20,
  height: 20,
  color: theme.colors.red
}))`
  cursor: pointer;
  transform: scale(1);
  transition: transform 350ms ease;
  @media only screen and (min-width: 1024px) {
    &:hover {
      transform: scale(1.25);
    }
  }
`;

export const CheckIcon = styled(IconCheck).attrs(({theme}) => ({
  width: 22,
  height: 22,
  color: 'transparent'
}))`
  cursor: pointer;
  transform: scale(1);
  transition: transform 350ms ease;
  margin-left: 15px;
  @media only screen and (min-width: 1024px) {
    &:hover {
      transform: scale(1.25);
    }
  }
`;

export const PdfIcon = styled(IconDocument).attrs(({theme}) => ({
  width: 26,
  height: 26,
  color: theme.colors.grayDark,
}))`
  cursor: pointer;
  transform: scale(1);
  transition: transform 350ms ease;
  margin-left: 12px;
  @media only screen and (min-width: 1024px) {
    &:hover {
      transform: scale(1.25);
    }
  }
`;

export const DownloadIcon = styled(IconDownload).attrs(({theme}) => ({
  width: 26,
  height: 26,
  stroke: theme.colors.grayDark,
  color: 'transparent'
}))`
  cursor: pointer;
  transform: scale(1);
  transition: transform 350ms ease;
  margin-left: 12px;
  @media only screen and (min-width: 1024px) {
    &:hover {
      transform: scale(1.25);
    }
  }
`;

export const TrashIcon = styled(IconTrash).attrs(({theme}) => ({
  width: 26,
  height: 26,
  stroke: theme.colors.red,
  color: 'transparent'
}))`
  cursor: pointer;
  transform: scale(1);
  transition: transform 350ms ease;
  margin-left: 12px;
  @media only screen and (min-width: 1024px) {
    &:hover {
      transform: scale(1.25);
    }
  }
`;

// PaginationArea

export const NavigationRow = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
`;

export const ArrowIconRight = styled(IconArrow).attrs<{ disabled: boolean }>(({theme}) => ({
  width: 30,
  height: 30,
  color: theme.colors.white,
}))`
  fill: none;
  background-color: ${({theme}) => theme.colors.primary};
  padding: 4px;
  border-radius: 50%;
  transform: scale(1) rotate(270deg);
  transition: transform 350ms ease;
  margin-left: 12px;
  opacity: ${({disabled}) => disabled ? 0.4 : 1};
  cursor: ${({disabled}) => disabled ? 'default' : 'pointer'};

  @media only screen and (min-width: 1024px) {
    &:hover {
      transform: scale(1.25) rotate(270deg);
    }
  }
`;

export const ArrowIconLeft = styled(IconArrow).attrs<{ disabled: boolean }>(({theme}) => ({
  width: 30,
  height: 30,
  color: theme.colors.white,
}))`
  fill: none;
  background-color: ${({theme}) => theme.colors.primary};
  padding: 4px;
  border-radius: 50%;
  transform: scale(1) rotate(90deg);
  transition: transform 350ms ease;
  margin-left: 12px;
  opacity: ${({disabled}) => disabled ? 0.4 : 1};
  cursor: ${({disabled}) => disabled ? 'default' : 'pointer'};
  @media only screen and (min-width: 1024px) {
    &:hover {
      transform: scale(1.25) rotate(90deg);
    }
  }
`;
